<template>
    <div class="snoop-form-group">
        <label class="snoop-checkbox__label">
            <snoop-html-content tag="span" :html="label" />
            <span :class="`qa-${id}`" class="snoop-checkbox" @click.stop>
                <input
                    :id="id"
                    :name="id"
                    type="checkbox"
                    :checked="value"
                    :disabled="isDisabled"
                    :class="{ 'snoop-checkbox--active': value, 'snoop-checkbox__input': true }"
                    value="1"
                    @change="onInput"
                >
                <span :class="{'snoop-checkbox--disabled': isDisabled, 'snoop-checkbox__slider': true } " />
            </span>
        </label>
    </div>
</template>

<script>
import { hasCookieUnacceptedRequirement } from '../util/cookie'
import SnoopHtmlContent from './HtmlContent.vue'


export default {
    components: { SnoopHtmlContent },

    props: {
        id: { type: String, required: true },
        label: { type: String, required: true },
        value: { type: Boolean, required: true },
        requires: { type: Array, default: () => [] },
        acceptedCookieIds: { type: Array, default: null },
    },

    computed: {
        isDisabled () {
            return hasCookieUnacceptedRequirement(this.requires, this.acceptedCookieIds)
        },
    },

    methods: {
        onInput (event) {
            this.$emit('input', event.target.checked)
        },
    },
}
</script>
